import styled from "styled-components";

export const CollectionOverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
